import { render, staticRenderFns } from "./hqLxsrOther.vue?vue&type=template&id=643845b6&scoped=true&"
import script from "./hqLxsrOther.vue?vue&type=script&lang=js&"
export * from "./hqLxsrOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643845b6",
  null
  
)

export default component.exports